import { useQuery } from 'react-query';
import { fetchWork } from './api';

export const useWorkPeriodsQuery = (token: string | undefined) =>
  useQuery(['workPeriods', token], () => fetchWork(token), {
    enabled: !!token,
    keepPreviousData: true
  });
